export function formatTime(timestamp: number): string {
  const date = new Date(timestamp);
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const day = date.getUTCDate();

  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
}
